import { setToken } from '@/utils/auth'

function readTokenFromLocation() {
  if (typeof window === 'undefined') return ''

  const url = new URL(window.location.href)
  let token = url.searchParams.get('token')

  // hash：#/?token=xxx 或 #/path?token=xxx
  if (!token && url.hash.includes('?')) {
    const hashQuery = url.hash.split('?')[1] || ''
    token = new URLSearchParams(hashQuery).get('token')
  }

  // 兜底：部分环境 search 异常时从 href 正则取
  if (!token) {
    const m = window.location.href.match(/[?&#]token=([^&#]+)/)
    if (m && m[1]) {
      try {
        token = decodeURIComponent(m[1])
      } catch (e) {
        token = m[1]
      }
    }
  }

  return token || ''
}

function stripTokenFromUrl() {
  const url = new URL(window.location.href)
  url.searchParams.delete('token')

  let hash = url.hash || ''
  if (hash.includes('?')) {
    const [hashPath, hashQuery = ''] = hash.split('?')
    const hp = new URLSearchParams(hashQuery)
    hp.delete('token')
    const left = hp.toString()
    // history 模式不需要残留 #/
    if (hashPath === '#/' || hashPath === '#') {
      hash = left ? `${hashPath}?${left}` : ''
    } else {
      hash = left ? `${hashPath}?${left}` : hashPath
    }
  }

  const search = url.searchParams.toString()
  const next = `${url.pathname}${search ? `?${search}` : ''}${hash}`
  window.history.replaceState(null, '', next)
}

/**
 * 消费后台「一键登录」链接中的 token
 * @returns {boolean}
 */
export function consumeTokenFromUrl() {
  const token = readTokenFromLocation()
  if (!token) return false

  setToken(token)
  stripTokenFromUrl()
  return true
}
